<div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
            <p class="text-muted">
                RISIKOVURDERING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2>{{location?.number}}</h2>
            <p>
                <span class="text-muted">Sagsbehandler: </span>
                <a>{{location?.caseWorker?.name}}</a>
            </p>
            <h2>Oprettet af: foreløbig screening</h2>
            <p *ngIf="location.isLandfill" i18n>Losseplads</p>
        </div>
    </div>
</div>

<div class="container mb-5">
    <div *ngIf="pageStates.isLoadingModel" class="mt-5 text-center">
        <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
        <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter lokalitet... </h3>
        <p class="text-muted mt-1">Det tager et øjeblik</p>
    </div>
    <div *ngIf="!pageStates.isLoadingModel">
        <div class="row mt-5 ">
            <div class="col-md-8 alert alert-secondary p-4"
                style="background: #F4F7F9; border-color:rgba(201, 201, 219, 0.356)">
                <h1>Foreløbig risikovurdering</h1>
                <h3 class="mb-0">Beregninger kan ikke opløftes til godkendte beregninger</h3>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-sm-12 col-lg-12">
                <h4 class="d-inline-block" i18n>Foreløbige beregninger</h4>
                <!-- <a href="javascript:void(0)" class="text-uppercase float-right btn btn-primary btn-sm"
                        (click)="newCalculation(null)">
                        <i class="fa fa-plus-circle fa-lg"></i>
                        <span class="text-uppercase"> ny beregning</span>
                    </a> -->
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Dato</th>
                            <th>Forureningsstof</th>
                            <th>Risikovurdering</th>
                            <th>Overskridelsesfaktor</th>
                            <th>Koncentration</th>
                            <th>Kvalitetskriterie</th>
                            <th>Beregningsmodel</th>
                            <th>Sagsbehandler</th>
                            <th>Bemærkning</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let calc of location.preliminaryCalculations"
                            (click)="goToCalculationResults(calc.id);">
                            <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy HH:mm'}}</td>
                            <ng-container *ngIf="!calc.isInProgress && !calc.calculationFailed">
                                <td>{{calc.compoundName}}</td>
                                <td>
                                    <span class="fa-stack risk-indicator"
                                        [ngClass]="{'risk-computed':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-computed':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                                    </span>
                                    <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                        <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                            <b>Risiko</b>
                                        </span>
                                        <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                                    </span>
                                </td>
                                <td>
                                    <span [ngSwitch]="calc.riskAssessment">
                                        <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                            <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                        </span>
                                        <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                            {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                        </span>
                                    </span>
                                </td>
                                <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                                <td>
                                    {{getValidNumber(calc.qualityCriterion) | number:'1.0-2'}} µg/L
                                    {{ calc.qualityCriterionType === qualityCriterionType.Fictitious ? '(*)' : '' }}
                                </td>
                                <td class="text-nowrap">
                                    <span class="model-indicator">
                                        <i class="model-icon"></i>
                                        <span class="model-number">{{calc.calculationModelType}}</span>
                                    </span>
                                    <span class="text-muted">(nedbrydning:</span>
                                    <span *ngIf="!calc.hasDegradation"> nej</span>
                                    <span *ngIf="calc.hasDegradation"> ja</span>
                                    <span class="text-muted">)</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="calc.isInProgress">
                                <td colspan="6">Beregner...</td>
                            </ng-container>

                            <ng-container *ngIf="calc.calculationFailed">
                                <td colspan="6">
                                    <div class="alert alert-danger m-0 p-1" role="alert">
                                        <b><i class="fa fa-exclamation fa-lg"></i>Beregningen fejlede:</b>
                                        {{calc.calculationFailedErrorMessage}}
                                    </div>

                                </td>
                            </ng-container>

                            <td>{{calc.caseWorker?.name}}</td>
                            <ng-container *ngIf="this.modalCalculationId === calc.id && pageStates.isAddingComment; else showComment">
                                <td>
                                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                                </td>
                            </ng-container>
                            <ng-template #showComment>
                                <td *ngIf="calc.latestComment"><span class="text-muted">"{{calc.latestComment}}"</span></td>
                                <td *ngIf="!calc.latestComment" (click)="$event.stopPropagation();">
                                    <a (click)="showAddCommentModal(calc.id)" class="text-uppercase">Tilføj bemærkning</a>
                                </td>
                            </ng-template>
                        </tr>
                    </tbody>
                </table>
                <span *ngIf="location.preliminaryCalculations && location.preliminaryCalculations.length"
                    class="text-muted">
                    (*) fiktiv værdi er anvendt.
                </span>
            </div>
        </div>

        <div *ngIf="location" class="row mt-5" [hidden]="isExternalUser">
            <div class="col-sm-12 col-lg-12">
                <h4 class="d-inline-block" i18n>Foreløbig screeninger på denne lokalitet</h4>
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Dato</th>
                            <th>Forureningsstof</th>
                            <th>Risikovurdering</th>
                            <th>Overskridelsesfaktor</th>
                            <th>Koncentration</th>
                            <th>Kvalitetskriterie</th>
                            <!-- <th class="text-right font-weight-normal text-uppercase">
                              <a>se screeningshistorik</a>
                            </th> -->
                            <th *ngIf="publicActionPerformed"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let calc of location.preliminaryResults">
                            <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy'}}</td>
                            <td>{{calc.compoundName}}</td>
                            <td>
                                <span class="fa-stack risk-indicator"
                                    [ngClass]="{'risk-screening':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-screening':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                                </span>
                                <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>Risiko</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                                </span>
                            </td>
                            <td>
                                <span [ngSwitch]="calc.riskAssessment">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                        {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                    </span>
                                </span>
                            </td>
                            <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                            <td>
                                {{getValidNumber(calc.qualityCriterion) | number:'1.0-2'}} µg/L
                                {{ calc.qualityCriterionType === qualityCriterionType.Fictitious ? '(*)' : '' }}
                            </td>
                            <td class="text-right" *ngIf="publicActionPerformed">
                                <a (click)="newCalculation(calc)">
                                    <span i18n>
                                        <i class="fa fa-plus-circle fa-lg"></i>
                                        <span class="text-uppercase"> ny beregning</span>
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span *ngIf="location.preliminaryResults && location.preliminaryResults.length"
                    class="text-muted">
                    (*) fiktiv værdi er anvendt.
                </span>
            </div>
        </div>
    </div>

    <button #addCommentModalButton style="display:none;" data-toggle="modal" data-target="#modalAddComment"></button>


    <div class="modal fade" id="modalAddComment" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Tilføj note</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <textarea #textMessage class="form-control" placeholder="Skriv note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="addCommentFromModal(textMessage.value)" type="button" class="btn btn-primary"
                        data-dismiss="modal">Tilføj</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>
</div>